import "./StudyFiltersManagements.scss";
import T from "../../../../shared/component/t/T";
import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import snippets from "../../../../helpers/snippets";
import Storage from "../../../../helpers/Storage";

function StudyFiltersManagements(props) {
    const [ device ] = useState(props.device)
    const [ show, setShow ] = useState()
    const [ options, setOptions ] = useState([])
    const [ selected, setSelected ] = useState()
    const [ default_id, setDefault_id ] = useState(Storage.getDefaultStudyFilterID())

    useEffect(() => {
       setShow(props.show)
    }, [props.show]);

    useEffect(() => {
        if (snippets.isObjectEmpty(props.studyFilterOptions)){
            setOptions( [...Object.values(Storage.getStudyFilters()).map((item)=>{
                return {id: item.id, value: item.id, text: item.title, filters_json: item.filters_json}
            })])
            setSelected(-1)
        } else {
            setOptions(props.studyFilterOptions)
            setSelected(props.studyFilterSelected)
        }
    }, [props.studyFilterOptions, props.studyFilterSelected]);

    const closeModal = () => {
        props.onClose()
    }

    const reset = () => {
        props?.studyFilterReset()
        closeModal()
    }

    const studyFilterChange = (id) => {
        props?.studyFilterChanges(id)
    }

    const apply = (id) => {
        props?.studyFilterApply(id)
    }

    const markAsDefault = (item) => {
        props?.studyFilterDeafult(item.id).then(()=>{
            setDefault_id(item.id)
        })
    }

    const details = (item) => {
        props?.showDetails(item)
    }

    const showDeleteModal = (item) => {
        props?.showDelete(item)
    }

    return ( <>
        <Modal show={show}
               onHide={closeModal}>
            <div className={'imodal study_filter_showAll'}>
                <div className={'imodal__header'}>
                    <div className={'imodal__close'} onClick={closeModal}>
                        <i className={'fa fa-light fa-times-circle'}/>
                    </div>
                    <div className={'imodal__title'}><T token={'quick_filters_list'}/></div>
                </div>
                <div className={'imodal__body'}>
                    <div className={"study_filter_showAll_list"}>
                        {options?.map((item, index) =>
                            <div className={`item ${item.id === selected ? "selected" : ""}`} key={index}>
                                <div  className={"item_title"} > {item.text} </div>
                                <div  className={"item_buttons"} >
                                    {/*<div className={`details_button ${default_id.toString() === item.id.toString() ? "selected" : ""}`} onClick={()=>{markAsDefault(item)}}> <T token={"default"} /> </div>*/}
                                    <div className={"details_button"} onClick={()=>{details(item)}}> <T token={"details"} /> </div>
                                    <div className={"apply_button"} onClick={()=>{apply(item.id)}}> <T token={"apply_filter"} /> </div>
                                    {/*<div className={"delete_button"} onClick={()=>{showDeleteModal(item)}}> <T token={"delete"} /> </div>*/}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className={'imodal__action'}>
                    {device !== "desktop" &&
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={() => studyFilterChange("-2")}>
                            <T token={'study_filter_new'}/>
                        </div>}

                    {(options?.length > 0 && device !== "desktop") &&
                        <div className={'imodal__btn imodal__btn--secondary'}
                             onClick={reset}>
                            <T token={'study_filter_cancel'}/>
                        </div>}

                    { device === "desktop" &&
                        <div className={'imodal__btn imodal__btn--secondary'}
                             onClick={closeModal}>
                            <T token={'close'}/>
                        </div>}
                </div>
            </div>
        </Modal>
    </>
    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const device = state.DeviceModeReducer.mode;
    return {language, device};
};

export default connect(mapStateToProps)(StudyFiltersManagements);